import React from 'react';
import { Box, Typography, Grid, CardMedia, IconButton } from '@mui/material';
import { ArrowForward } from '@mui/icons-material';

const ConceptSection = ({ handleReadMore }) => (
    <Box className='note-concept' sx=
        {{
            backgroundColor: '#f5f5f5',
            maxWidth: 'lg',
            mx: {
                xs: 2, // small margin on extra small screens
                sm: 4, // larger margin on small screens
                md: 6, // even larger margin on medium screens
                lg: 10, // original margin on large screens
            },
            p: 3,
            mt: 10,
            mb: 5,
            borderRadius: '1rem'
        }}>

        <Typography variant="h4" gutterBottom align="center" sx={{ mt: 4, mb: 4, color: '#000', fontWeight: 'bold' }}>
            BEADS' CONCEPT NOTE
        </Typography>

        <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={4}>
                <CardMedia
                    component="img"
                    image="/assets/img/news/debbie.jpg"
                    alt="CEO & Founder BEADS for Education"
                    sx={{ borderRadius: '0.8rem', width: '100%', height: 'auto' }}
                />
            </Grid>

            <Grid item xs={12} md={8}>
                <Typography gutterBottom variant="h6" sx={{ color: '#000', fontSize: 'medium' }}>
                    Debby Rooney - CEO & FOUNDER BEADS for Education
                </Typography>

                <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
                    I am Debby Rooney, the Founder and CEO of BEADS for Education. BEADS is a 501©(3) non-profit based in the United States. Since 1998, we have been sponsoring girls’ education, mostly from the marginalized Maasai community in Kenya. 52 million girls in sub-Saharan Africa have never attended school. Our sponsored girls feel especially blessed to be enrolled in the BEADS high school. In the Maasai community, most parents do not have enough money to send their girls to high school...
                </Typography>

                <IconButton onClick={handleReadMore} sx={{ backgroundColor: '#dde7f1', fontSize: 'small', borderRadius: '1.5rem', '&:hover': { transform: 'scale(1.1)' } }}>
                    Read More <ArrowForward sx={{ color: 'primary.main' }} />
                </IconButton>
            </Grid>
        </Grid>
    </Box>
);

export default ConceptSection;
